import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/timeoff/pages/calendar_teams/RootPage'))
const TeamViewEditLeavePage = React.lazy(
  () => import('modules/timeoff/pages/calendar_teams/TeamViewEditLeavePage')
)
const TeamViewRejectLeavePage = React.lazy(
  () => import('modules/timeoff/pages/calendar_teams/TeamViewRejectLeavePage')
)

const calendarTeamsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: '',
      element: <RootPage />,
      children: [
        {
          path: navigation.calendar.teamView.leavesEditLeaveId.path,
          element: <TeamViewEditLeavePage />,
        },
        {
          path: navigation.calendar.teamView.leavesRejectLeaveId.path,
          element: <TeamViewRejectLeavePage />,
        },
      ],
    },
  ]
}

export default calendarTeamsRoutes
